import styled from "styled-components";
import { theme } from "../../../helpers/theme";
import * as yup from "yup";
import { useFormik } from "formik";
import { Input } from "../../../components/Input/input";
import { StyledButton } from "../../../components/Button/button";
import { useLocation, useParams } from "react-router-dom";
import { changeLogin } from "../../../services/users/change-login";
import { toast, ToastOptions } from "react-toastify";
import { useMutation } from "@tanstack/react-query";
import { GoBackButton } from "../../../components/GoBackButton";


const EditUserLogin = () => {
  const { id } = useParams<{ id: string }>();
  const { state } = useLocation();
  const { login } = state;

  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };


  const ChangeLogin = useMutation(changeLogin, {
    onSuccess: () => {
      toast.success("Zmieniono login!", { toastId: "DeletedSuccessfully", ...settings });
    },
  });

  const loginRegex = /^[a-zA-Z0-9@!.]+$/;

  const validationSchema = yup.object({
    login: yup
      .string()
      .required("Pole wymagane")
      .matches(loginRegex, "Login może zawierać tylko litery, cyfry, @ i !")
      .min(3, "Login musi zawierać minimum 3 znaki"),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      login: String(login),
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        id_uzytkownik: id,
        nowy_login: values.login,
      };
      // console.log(body);
      ChangeLogin.mutate(body);
    },
  });


  return ( 
    <>
    <ButtonWrapper>
    <GoBackButton description={"Powrót"} goToUrl={-1} />
    </ButtonWrapper>
      <EditUserLoginFormWrapper>
      <BasicFormWrapper onSubmit={formik.handleSubmit}>
        <FormWrapper>
        <Input
            label="Login"
            id="login"
            name="login"
            value={formik.values.login}
            onChange={formik.handleChange}
            error={
              formik.touched.login && Boolean(formik.errors.login)
            }
            helperText={formik.touched.login && formik.errors.login}
            onBlur={formik.handleBlur}
            variant="filled"
            style={{ marginTop: 11 }}
          />
          <StyledButton
            disabled={
              !formik.isValid ||
              ChangeLogin.isLoading
            }
            type="submit"
            variant="contained"
          >
            Zapisz
          </StyledButton>
        </FormWrapper>
      </BasicFormWrapper>
      </EditUserLoginFormWrapper>
    </>
  );
}

export default EditUserLogin;

const ButtonWrapper = styled.div`
  width: 70%;
  margin-left: 30px;
  z-index: 10000;
  // display: flex;
  // justify-content: flex-start;


  @media (${theme.device.laptop}) {
    margin-left: 320px
  }
`;

const EditUserLoginFormWrapper = styled.div`
width: auto;
  display: flex;
  flex-direction: column;
  margin-left: 320px;
  padding-right: 0;
  margin-top: 0px;
  @media (${theme.device.laptop}) {
    width: 70%;
  }
`;

const BasicFormWrapper = styled.form`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // padding: 0 40px;

  @media (${theme.device.laptop}) {
    width: 100%;
    // padding: 0 10px;
  }
`;

const FormWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 260px;
  max-width: 420px;
  gap: 25px;

  @media (${theme.device.laptop}) {
    width: 100%;
  }
`;
